import { useState } from 'react';

import { Avatar, Skeleton, Stack, Typography } from '@mui/material';
import cx from 'classnames';
import { NavLink, useLocation } from 'react-router';

import styles from './ProfileMenuItem.module.scss';
import { useGetUserMe } from '@/api/REST/userMe';
import { Icon } from '@/components/ui/Icon';
import { profileMenuItem } from '@/constants/menuItems';
import { useGetFrontendAddressUrl } from '@/legacy/apis/indexAPI/getIndexAPI';
import { parseBooleanFromString } from '@/legacy/utils/boolean';
import { tlpBase } from '@/utils/gateway';

export const ProfileMenuItem = () => {
  // Check if user is authenticated in TLP to avoid redirect to profile image when fetching profile picture
  const { isSuccess: userIsAuthenticatedInTLP } = useGetFrontendAddressUrl();

  const { data: userMeData, isLoading } = useGetUserMe();
  const [hovered, setHovered] = useState(false);
  const { pathname } = useLocation();
  const isActive = pathname.startsWith(profileMenuItem.base);

  if (isLoading || !userMeData) {
    return <Skeleton width={180} height={20} />;
  }

  const {
    profilePicture: tlpProfilePictureUrl,
    companyName,
    fullName,
  } = userMeData;

  const BYPASS_TLP = parseBooleanFromString(import.meta.env.VITE_BYPASS_TLP);

  const absoluteProfilePictureUrl =
    tlpProfilePictureUrl && tlpProfilePictureUrl !== ''
      ? tlpBase() + tlpProfilePictureUrl
      : null;

  return (
    <NavLink
      className={cx(styles.ProfileMenuItem, {
        [styles.ProfileMenuItemActive]: isActive,
      })}
      to={profileMenuItem.start}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      tabIndex={0}
      data-automation-id={`MainNavigation${profileMenuItem.id}ParentLink`}
    >
      {absoluteProfilePictureUrl && userIsAuthenticatedInTLP && !BYPASS_TLP ? (
        <Avatar
          alt={fullName}
          src={absoluteProfilePictureUrl}
          sx={{ width: 22, height: 22 }}
        />
      ) : (
        <Icon
          name={profileMenuItem.icon}
          weight={hovered || isActive ? 400 : 300}
        />
      )}
      <Stack gap={0}>
        <Typography variant="bodySemiBold">{fullName}</Typography>
        <Typography variant="label">{companyName}</Typography>
      </Stack>
    </NavLink>
  );
};
